// extracted by mini-css-extract-plugin
export var hideEditor = "_j6-2";
export var infoIcon = "_j6-3";
export var label = "_j6-1";
export var labelContainer = "_j6-0";
export var readonlyText = "_j6-4";